import { Container } from "@modules/pixi.js/lib";
import { MultiBonusPIXIApp } from "./MultiBonusPIXIApp";
import { ResponsiveView, ResponsiveSizeContainer, FixedSizeFitContainer } from "../../../../singlegame/ResponsiveHelpers";
import { CreateSpineResources, Point, Rect, Safe, Scale, Size, TranslateScreen1To1 } from "../../../MyHelpers";
import * as PIXI from "pixi.js";
import { JackpotDisplayType, Settings } from "../../../Settings";
import { assertNotLess, assertNotNullish } from "../../../debug";
import { SpinTargetParams } from "../../SpinAnimation/SpinTargetParams";
import { AwardType, JackpotAwardOption, JackpotLevel, Money, MultiBonusType, ScatterRandomAwardResult } from "../../../../singlegame/singlegame_api";
import { IBonusStartConfig } from "../../SlotGame";
import { GetOrientation, Orientation } from "../../../FitScreen";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager } from "../../../ResourceManager/ResourceManager";
import { ITransitionFactoryPIXIAPP } from "../../Transition/ITransitionFactoryPIXIAPP";
import { TransitionFactoryPIXIAPP } from "../../Transition/TransitionFactoryPIXIAPP";
import { service } from "../../../services";
import { S2_SpinnableReelsBigCanvas2 } from "../../SpinAnimation2/SpinnableReelsBigCanvas2";
import { COMET_PATH, ConstructReelsParams } from "../SlotBonus";
import { SpinAndHoldState } from "../SpinAndHold/SpinAndHoldState";
import gsap from "gsap";
import { FountainPIXI } from "../../FountainAnimationPIXI";
import { SharedJackpotWin, SpinAndHoldCommonConfiguration } from "../../../api";
import { Text } from "pixi.js";
import { AwardJPShowPIXIAPPResponsive } from "../SpinAndHold/AwardJPShowPIXIAPPResponsive";
import { SpinAndHoldParams } from "../SpinAndHold/SpinAndHoldParams";
import { JackpotShowtimeDuration } from "../../../JackpotProperties";
import { serviceProvider } from "../../../../singlegame/SinglegameServiceMap";

export class MultiBonusPIXIAppResponsive extends MultiBonusPIXIApp {

	protected responsiveView: ResponsiveView;
	protected responsiveViewStats: ResponsiveView;
	protected responsiveStatsContainer: ResponsiveSizeContainer;
	protected statsContainer: FixedSizeFitContainer;
	protected baseGameContainer: ResponsiveSizeContainer;
	protected panelContainer: ResponsiveSizeContainer;

	protected override awardJPShowPIXIAPP: AwardJPShowPIXIAPPResponsive = null;


	protected fountainAnimation = serviceProvider.Resolve("FountainPIXI");


	private isDouble: boolean = false;
	protected override containerBonusViewApp: FixedSizeFitContainer = null;

	public constructor(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration) {
		super(gameName, params, config);
		this.awardJPShowPIXIAPP = new AwardJPShowPIXIAPPResponsive();
	}



	// protected created: boolean = false;
	protected createResponsiveElements() {


		this.responsiveView = new ResponsiveView(window.innerWidth, window.innerHeight, { color: 0x220000, name: 'responsive-view' });
		this.responsiveViewStats = new ResponsiveView(window.innerWidth, window.innerHeight, { color: 0x220000, name: 'responsive-view-stats' })

		this.responsiveStatsContainer = new ResponsiveSizeContainer(0, 0, 1, 1, NaN, { color: 0x550000, secondaryColor: 0x005500, name: 'stats-container-responsive' });
		this.responsiveViewStats.addChild(this.responsiveStatsContainer);

		this.statsContainer = new FixedSizeFitContainer(Scale.W(1920), Scale.H(1080), { color: 0x550000, secondaryColor: 0x005500, name: 'stats-container' });
		this.responsiveStatsContainer.addChild(this.statsContainer);

		this.baseGameContainer = new ResponsiveSizeContainer(0, 0, 1, 1, NaN, { color: 0x990000, name: 'base-game-container' });
		this.responsiveView.addChild(this.baseGameContainer);

		this.containerBonusViewApp = new FixedSizeFitContainer(Scale.W(1920), Scale.H(1080), { color: 0xbb0000, name: 'reels-container' });
		this.baseGameContainer.addChild(this.containerBonusViewApp);

		this.panelContainer = new ResponsiveSizeContainer(0, 0.85, 1, 0.15, NaN, { color: 0xee0000, name: 'panel-container' });
		this.responsiveView.addChild(this.panelContainer);

		this.gameViewApp.addChild(this.responsiveViewStats, this.responsiveView);

	}

	public override async PrepareTransition(resourceManager: IWriteOnlyResourceManager): Promise<void> {

		// let pathTrack: string;
		// let pathSprite: string;
		// let pathVideo: string;
		// if (Settings.JackpotDisplayType != JackpotDisplayType.PaytableJackpotDisplay) {
		// 	let pathTrack = this.params.commonpath + "resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/tracks/" + Settings.JackpotDisplayType + Settings.audioFormat;
		// 	let pathSprite = this.params.commonpath + "resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/" + Settings.JackpotDisplayType + "_Transition";
		// 	let pathVideo = this.params.commonpath + "resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/Background_" + Settings.Screens + "S";
		// 	//Overwrite this video path because for this jackpots need different 
		// 	if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPot || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotOrtiz || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStep || Settings.JackpotDisplayType == JackpotDisplayType.DragonJackpot || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotRappidFrames) {
		// 		pathVideo = Settings.ResourcesFolder + "multigame/slot/" + this.gameName + "/resources/video/presentation_" + Settings.Screens + "s";
		// 		//pathTrack  = this.params.commonpath + "resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/tracks/DiamondPot" + Settings.audioFormat;
		// 	}

		// 	//if(Settings.JackpotDisplayType !+ JackpotDisplayType.DiamondPotStepShared && Settings.JackpotDisplayType != JackpotDisplayType.DiamondPotStepSinShared ) resourceManager.AddGlobal(new SpriteResource(pathSprite, ResourceIdentifier.Global.Add("TitleTransition").Add(this.bonusName), true, LogGroup.Global.Add("TitleTransition").Add(this.bonusName), true))
		// 	if(globalThis.jackpotDisplayGlobal.GetSpineSkeleton() == null)  resourceManager.AddGlobal(new SpriteResource(pathSprite, ResourceIdentifier.Global.Add("TitleTransition").Add(this.bonusName), true, LogGroup.Global.Add("TitleTransition").Add(this.bonusName), true))
		// 	this.audio.AddTrack(new Track(pathTrack, this.resid.ScopedResourceName("VoiceJackpotType")));

		// 	if (Settings.PresentationType == Presentation.VideoGameSprite) {
		// 		resourceManager.AddGlobal(new VideoResource2({
		// 			resid: ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + Settings.Screens),
		// 			logGroup: LogGroup.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + Settings.Screens),
		// 			src: pathVideo,
		// 			unloadOnHide: true
		// 		}));
		// 	}
		// 	else if (Settings.PresentationType == Presentation.VideoCommonNoSprite) {
		// 		pathVideo = this.params.commonpath + "resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/BackgroundVideoSprite_" + Settings.Screens + "S";
		// 		resourceManager.AddGlobal(new VideoResource2({
		// 			resid: ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + Settings.Screens),
		// 			logGroup: LogGroup.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + Settings.Screens),
		// 			src: pathVideo,
		// 			unloadOnHide: true
		// 		}));
		// 	}
		// 	else if (Settings.PresentationType == Presentation.Image) {
		// 		let pathImgTransition = this.params.commonpath + "resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/BackgroundTransition_" + Settings.Screens + "S.png";
		// 		if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPot || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotOrtiz || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStep) {
		// 			pathImgTransition = `${this.params.gamepath}resources/BackgroundTransition_${Settings.Screens}S.png`;
		// 		}
		// 		resourceManager.AddGlobal(new ImageResource(pathImgTransition,
		// 			ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-BackgroundTransition-" + Settings.Screens).Scope()));

		// 	}
		// 	else if (Settings.PresentationType == Presentation.VideoCommonClassic) {
		// 		pathVideo = this.params.commonBonusResourcesBasePath + "resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/BackgroundCommonVideo_" + Settings.Screens + "S";
		// 		resourceManager.AddGlobal(new VideoResource2({
		// 			resid: ResourceIdentifier.Global.Add(this.bonusName + "-Transition-" + Settings.Screens),
		// 			logGroup: LogGroup.Global.Add(this.bonusName + "-Transition-" + Settings.Screens),
		// 			src: pathVideo,
		// 			unloadOnHide: true
		// 		}));
		// 	}
		// 	else if (Settings.PresentationType == Presentation.VideoParticleTransitionMatterJS) {
		// 		resourceManager.Add(new PixiSpriteResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/symbolFillingPotPartitle-Transition`, this.resid.Add("Partitle-Transition").Shared(), true, this.logGroup.Add("Partitle-Transition"), true));
		// 		// resourceManager.AddGlobal(new JSONResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/partitleTransitionBoundingBox.json`,
		// 		// ResourceIdentifier.Global.Add(this.gameName + "-" +this.bonusName + "-partitleTransitionBoundingBox").Shared().CSSScope(),true));
		// 	}
		// 	else if (Settings.PresentationType == Presentation.VideoParticleTransitionFadeInFadeOut) {
		// 		resourceManager.Add(new PixiSpriteResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/symbolFillingPotPartitle-Transition`, this.resid.Add("Partitle-Transition").Shared(), true, this.logGroup.Add("Partitle-Transition"), true));
		// 		// resourceManager.AddGlobal(new JSONResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/partitleTransitionBoundingBox.json`,
		// 		// ResourceIdentifier.Global.Add(this.gameName + "-" +this.bonusName + "-partitleTransitionBoundingBox").Shared().CSSScope(),true));
		// 	}
		// }
		// else {
		// 	throw `Spin And Hold Its Not implemented for PrepareTransition ${Settings.JackpotDisplayType}`;
		// }

		let transitionResources = {
			audio: this.audio,
			logGroup: this.logGroup,
			systemContext: this.systemContext,
			gameName: this.gameName,
			resid: this.resid,
			fadeOut: true,
			skelentonDataSpine: globalThis?.jackpotDisplayGlobal?.GetSpineSkeleton() ?? null,
			transitionPIXITypeStyle: this.params.gameConfig.transitionPIXITypeStyle,
			bonusCommonPath: this.params.commonBonusResourcesBasePath,
			bonusName: this.bonusName,
		};

		let transitionViewFactory: ITransitionFactoryPIXIAPP = new TransitionFactoryPIXIAPP()
		this.transitionView = await transitionViewFactory.CreatePIXIAPPResponsive(transitionResources);
		await this.transitionView?.PrepareResources(resourceManager);

		this.transitionView.onTransitionEnd = () => {
			this.OnTransitionEnded()
		}

		this.transitionView.onTransitionStart = () => {
			this.OnTransitionStarted()
		}
	}

	private bonusAwardAnimation: TweenLite = null;

	public override Prepare(bonusStartConfig: IBonusStartConfig): void {
		super.Prepare(bonusStartConfig);
		this.isDouble = this.startAction.Types.find(mb => mb == MultiBonusType.Double) ? true : false;
	}

	public override async TransitionLoaded(resourceManager: IReadOnlyResourceManager) {
		await super.TransitionLoaded(resourceManager);

		this.transitionView.onTransitionStart = () => {
			this.OnTransitionStarted();

			if (this.startAction?.Types?.includes(MultiBonusType.Double) && globalThis.jackpotDisplayGlobal && Settings.Enable2plus1) {
				TweenLite.to(globalThis.jackpotDisplayGlobal.View(), 0.2, {
					alpha: 0
				});
			}
		}
	}

	public override Update(): void {
		super.Update();
		this.fountainAnimation?.Update();
	}

	public override GameSelected(app: Container): void {
		app.removeChildren();

		this.gameViewApp = app;
		this.createResponsiveElements();
		//create view main bonus 		
		//create award background show win jp	
		this.awardJPShowPIXIAPP.CreatePIXIAPP();
		this.gameViewApp.addChildAt(this.awardJPShowPIXIAPP.ViewPIXIAPP(), 0)

		this.ConstructReels2(this.constructReelsParams);

		assertNotNullish(this.containerBonusViewApp, "Container bonus view app must be created");
		this.spinnableReels2.Create(this.containerBonusViewApp);



		this.scatterRandomAwardFeature.UpdateReels({
			playWindow: this.startAction.PlayWindow,
			reelSet: this.config.MultiReelSets[this.startAction.ReelSetId].map(reel => reel.Symbols)
		});

		this.scatterRandomAwardFeature.UpdateBet(this.bet);
		this.scatterRandomAwardFeature.Start();



		let targets: SpinTargetParams[] = this.constructReelsParams.ReelSet.map(r => {

			let stop: number = 0;
			if (this.startAction.ReelStops &&
				this.startAction.ReelStops[r.Index]) {
				stop = this.startAction.ReelStops[r.Index];
			}

			return <SpinTargetParams>{
				position: stop,
				anticipation: false,
				firstAnticipationReelIndex: -1,
			};
		});

		this.reelSetMapper2.SetTargets(targets, true);

		const scatterRandomAward = this.startAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult;
		this.holdingFeature.UpdateReels(this.spinnableReels2);
		this.holdingFeature.CreatePIXIAPP();
		this.holdingFeature.Start(scatterRandomAward.ScattersPositionThisSpin, 1, this.params.symbolCollection.symbolCollectionMap.get("Symbol_SRA").showAward, false);


		this.CreateContainersPIXIAPPScreen1();
		this.CreateContainersPIXIAPPScreen2();

		if (this.jackpotSharedShow != null) {
			this.jackpotSharedShow.Create();
			this.containerBonusViewApp.addChild(this.jackpotSharedShow.View());
		}

		this.bonusMultiplier?.Create();
		if (this.bonusMultiplier) this.containerBonusViewApp?.addChild(this.bonusMultiplier.View());


		this.created = true;

		this.OnResize();
	}

	protected override CreateContainersPIXIAPPScreen2() {

		this.bonusGameInfoStats = new PIXI.Container();
		this.bonusGameInfoStats.name = "bonusGameInfoStats";
		this.layoutsContainer.addChild(this.bonusGameInfoStats);

		this.CreateTitleStckySpin();
		this.CreateScatterWinCount();
		//create text style
		// let textstyle = new PIXI.TextStyle({
		//     fontFamily: 'NotoSansDisplay-Bold',			
		// 	fontSize: Scale.fh(250),			
		// 	fontWeight: 'bold',
		// 	fill: ["#F2E416", "#F2BE22" , "#C2760E" , "#F2BE22", "#F2E416" ], // gradient
		// 	stroke: 'black',
		// 	strokeThickness: Scale.fh(10),			
		// 	//wordWrap: true,			
		// 	lineJoin: 'round',
		// 	//textBaseline : "middle",			
		// });

		//create Win Text SRA
		let winCountTextPIXIAPP = new PIXI.Text(this.session.ScattersDisplayed, {
			fontFamily: 'NotoSansDisplay-Bold',
			fontSize: 100,
			fontWeight: 'bold',
			fill: ["#F20505", "#F20505", "#F20505", "#F20505", "#F20505"], // gradient
			stroke: 'white',
			strokeThickness: 10,
			//wordWrap: true,			
			lineJoin: 'round',
			dropShadow: true,
			dropShadowColor: "#000000",
			dropShadowDistance: 5,
			dropShadowAngle: 0.52,
			dropShadowAlpha: 1,
			//textBaseline : "middle",			
		});
		winCountTextPIXIAPP.anchor.set(0.5, 0.5);
		winCountTextPIXIAPP.scale.set(1, -1);
		winCountTextPIXIAPP.position.set(100, 0);
		//winCountTextPIXIAPP.position.set(Scale.W(301),Scale.H(300));	   	   		
		//scatterWinCountContainer.addChild(winCountTextPIXIAPP);
		this.winCountTextPIXIAPP = winCountTextPIXIAPP;

		//Create Win Text SRA info
		let winTextPIXIAPP = new PIXI.Text(this.translator.t.totalwinHoldAndSpin, {
			fontFamily: 'NotoSansDisplay-Bold',
			fontSize: 50,
			fontWeight: 'bold',
			fill: ["#F20505", "#F20505", "#F20505", "#F20505", "#F20505"], // gradient
			stroke: 'white',
			strokeThickness: 10,
			wordWrap: true,
			lineJoin: 'round',
			align: "center",
			dropShadow: true,
			dropShadowColor: "#000000",
			dropShadowDistance: 5,
			dropShadowAngle: 0.52,
			dropShadowAlpha: 1,
			//textBaseline : "middle",			
		});
		winTextPIXIAPP.anchor.set(0.5, 0.5);
		winTextPIXIAPP.scale.set(1, -1);
		winTextPIXIAPP.position.set(-50, 0);
		//winTextPIXIAPP.position.set(Scale.W(300),Scale.H(440));	   	   		
		//scatterWinCountContainer.addChild(winTextPIXIAPP);

		//this.winCountTextPIXIAPP = winTextPIXIAPP;

		//add container to spine
		let containerchildrensSpineWinCount = this.spineWinCountContainer?.children as PIXI.Container[];
		containerchildrensSpineWinCount?.forEach((container) => {
			if (container.name == "containerValue") {
				container.addChild(winCountTextPIXIAPP);
				container.addChild(winTextPIXIAPP);
			}
		});


		this.CreateSpinsRemaining();
		this.translator.SetOnLanguageChangedCallback(() => {

			winTextPIXIAPP.text = this.translator.t.totalwinHoldAndSpin;
			//spinRemainingTextInfoPIXIAPP.text = this.translator.t.totalleftHoldAndSpin;
		});

		this.CreateAwarViewPIXIAPP();
	}

	protected override CreateTitleStckySpin(): void {
		//No title for online version
	}

	protected scatterWinCountContainer: PIXI.Container = null;


	protected override CreateScatterWinCount() {

		//create container and spine WinCount 
		this.scatterWinCountContainer = new Container();
		this.scatterWinCountContainer.name = "scatterWinCountContainer";
		// this.bonunsGameInfoStatsPIXIAPP.addChild(scatterWinCountContainer);
		this.layoutsContainer.addChild(this.scatterWinCountContainer);
		this.spineWinCountContainer = CreateSpineResources(this.jsonSpinsRemainingSpine);
		// scatterWinCountContainer.x = 0;
		// scatterWinCountContainer.y = 0;
		this.scatterWinCountContainer.addChild(this.spineWinCountContainer);
		this.scatterWinCountContainer.pivot.set(this.spineWinCountContainer.width / 2, this.spineWinCountContainer.height / 2);

		//scatterWinCountContainer.pivot.set(this.spineWinCountContainer.width / 2, this.spineWinCountContainer.height / 2);
		this.spineWinCountContainer?.state.setAnimation(0, "anim", true);
		//scatterWinCountContainer.scale.set(0.8);
	}


	protected override ConstructReelParams(constructReelsParams: ConstructReelsParams) {

		assertNotNullish(constructReelsParams.ReelSet, "ReelSet must be set when constructing reels");

		if (this.spinnableReels2) {
			this.spinnableReels2.Destroy();
		}

		this.spinnableReels2 = new S2_SpinnableReelsBigCanvas2(
			this.resid,
			{
				reelConfig: constructReelsParams.ReelSet,
				playWindow: constructReelsParams.PlayWindow
			},
			{
				windowRect: this.isDouble ? new Rect(0, 0, Scale.W(1920), Scale.H(1080 * 2)) : new Rect(0, 0, Scale.W(1920), Scale.H(1080)),//constructReelsParams.WindowRect,
				leftBorderWidth: this.params.spinnableReelsParams.leftBorderWidth,
				rightBorderWidth: this.params.spinnableReelsParams.rightBorderWidth,
				topBorderWidth: this.params.spinnableReelsParams.topBorderWidth,
				bottomBorderWidth: this.params.spinnableReelsParams.bottomBorderWidth,
				backgroundImage: this.params.spinnableReelsParams.backgroundImage,

				pixiSpritesByName: this.params.pixiSpritesByName,

			},
			this.systemContext,
			constructReelsParams.Extended
		);

		this.spinnableReels2.OnCreatedCallback = () => {
			this.ReelBackgroundLoaded();
			//this.redrawPixiReels();
		};
	}

	private reelsView: PIXI.Container = null;

	protected override CreateContainersPIXIAPPScreen1(): void {
		super.CreateContainersPIXIAPPScreen1();

		this.reelsView = this.containerBonusViewApp.children.find(c => c.name == "containerSpinnableReels2ViewAppBonus") as PIXI.Container;

		this.reelsView.addChild(this.holdingFeature.ViewPIXIAPP());
		this.reelsView.pivot.set(this.reelsView.width / 2, this.reelsView.height / 2);
		// this.reelsView.addChild(this.commetView.ViewPIXIAPP());
		this.reelsView.addChild(this.messageContainerPIXIAPP);



	}

	protected override SendWinInfo(win: number, jp?: JackpotLevel) {
		//this.screenProtocol?.Send(new SpinAndHoldMessages.WinValue(win), this.screenProtocolScope);	
		//missing send money formated
		this.winAwardBonus += win;
		this.containerValueWinAwardText.text = service.moneyFormatter.FormatCurrency(this.winAwardBonus);
		// if(jp != null) this.jackpotSharedShow?.SetAward(jp,win);

		if (jp != null) {

			// find jackpot award index from all award indexes
			let jackpotAwardIndex = -1;
			for (let i = 0; i <= this.currentScatterCometIndex; i++) {
				if (this.scatterPositions[i].AwardOptionPosition.AwardOption.AwardType == AwardType.Jackpot) {
					jackpotAwardIndex++;
				}
			}

		}
	}

	protected override async StartShowWin(jp: JackpotLevel, timerShow: number, award: Money) {
		// this.audio.Stop(this.resid.ScopedResourceName("background"));
		// //let video: MyVideo = this.systemContext.SharedVideoContext().GetVideo(ResourceIdentifier.Global.Add(jp));
		// let winJackpot : SharedJackpotWin =  null;
		// //{
		// // 	JackpotLevel: jp,
		// // 	WinAmount: award,
		// // 	BetCents: undefined,
		// // 	TotalBetCents: undefined,
		// // 	TotalJackpotAmount: undefined
		// // }
		// // this.jackpotSharedShow?.ShowShared(winJackpot);
		// this.awardJPShowPIXAPP?.SetSkin(jp);
		// this.awardJPShowPIXAPP?.StarAnim();
		// gsap.set(this.awardJPShowPIXAPP.ViewPIXIAPP(), { alpha: 0 });
		// this.awardJPShowPIXAPP.ViewPIXIAPP().visible = true;
		// gsap.to(this.awardJPShowPIXAPP.ViewPIXIAPP(), { alpha: 1, duration: 0.5 });

		// // SlotGameType1Shared.Instance().jackpotFountain.get(jp)?.Start(this.resid);
		// this.fountainAnimation.Create(this.containerBonusViewApp);
		// this.fountainAnimation.Start();

		// this.audio.Play(this.resid.ScopedResourceName(jp + "Background"));
		// this.audio.Play(this.resid.ScopedResourceName(jp + "Voice"));

		// gsap.to(this.awardJPShowPIXAPP.ViewPIXIAPP(), {
		// 	delay :  (timerShow - 700 ) / 1000, alpha: 0, duration: 0.5, onComplete: () => {
		// 		this.awardJPShowPIXAPP.StopAnin();
		// 		this.audio.Stop(this.resid.ScopedResourceName("clasploop"));
		// 		this.StopFontain(jp);
		// 		winJackpot = null;
		// 	}
		// });
		this.audio.Stop(this.resid.ScopedResourceName("background"));
		//let video: MyVideo = this.systemContext.SharedVideoContext().GetVideo(ResourceIdentifier.Global.Add(jp));
		let winJackpot: SharedJackpotWin = null
		//{
		// 	JackpotLevel: jp,
		// 	WinAmount: award,
		// 	BetCents: undefined,
		// 	TotalBetCents: undefined,
		// 	TotalJackpotAmount: undefined
		// }
		// this.jackpotSharedShow?.ShowShared(winJackpot);
		this.awardJPShowPIXIAPP?.SetSkin(jp);
		this.awardJPShowPIXIAPP?.StarAnim();
		gsap.set(this.awardJPShowPIXIAPP?.ViewPIXIAPP(), { alpha: 0 });
		this.awardJPShowPIXIAPP.ViewPIXIAPP().visible = true;
		gsap.to(this.awardJPShowPIXIAPP?.ViewPIXIAPP(), { alpha: 1, duration: 0.5 });

		// SlotGameType1Shared.Instance().jackpotFountain.get(jp)?.Start(this.resid);

		this.fountainAnimation.Create();
		await this.fountainAnimation.Start();

		//this.audio.Play(this.resid.ScopedResourceName(jp + "Background"));
		this.audio.Play(this.resid.ScopedResourceName(jp + "Voice"));

		gsap.to(this.awardJPShowPIXIAPP.ViewPIXIAPP(), {
			delay: (timerShow - 700) / 1000, alpha: 0, duration: 0.5, onComplete: () => {
				this.awardJPShowPIXIAPP.StopAnin();
				//this.audio.Stop(this.resid.ScopedResourceName("clasploop"));
				this.StopFontain(jp);
				winJackpot = null;
			}
		});
	}

	protected override StopFontain(jp: JackpotLevel) {
		//this.audio.Stop(this.resid.ScopedResourceName(jp + "Background"));
		this.audio.Stop(this.resid.ScopedResourceName(jp + "Voice"));
		//this.audio.PlayLoop(this.resid.ScopedResourceName("background"));
		// SlotGameType1Shared.Instance().jackpotFountain.get(jp)?.RequestStop(this.resid);
		this.fountainAnimation.Destroy();
	}


	protected override CreateLayoutBonus(): void {
		this.layoutsContainer = new Container();
		this.layoutsContainer.name = "layoutsContainerStats";
		//this.layoutsContainer.width = Settings.ScreenWidth;
		//this.layoutsContainer.position.set(Scale.X(66) , Scale.Y())
		this.statsContainer.addChild(this.layoutsContainer)
		let indexpot = 1;
		this.startAction.Types.forEach(potNameVarian => {
			this.layoutPotsElementsMap.get(potNameVarian).CreateElementIntoContainer(this.layoutsContainer, this.playWindow.Height >= 5 ? Scale.XY(0.6) : Scale.XY(0.7), indexpot, this.playWindow.Height >= 5 ? 4 : 3);
			this.layoutPotsElementsMap.get(potNameVarian).Enable();
			if (this.layoutPotsElementsMap.get(potNameVarian).potName == "Multiplier") this.layoutPotsElementsMap.get(potNameVarian).SetMultiplier(this.multiplierHit);
			indexpot++;
		});

		//this.layoutsContainer.position.set(Scale.X(-114), Settings.ScreenHeight * (Settings.Screens - 1) - Scale.Y(100));
		//SetNewPosition if you win more symbols 
		//if (this.playWindow.Height >= 5) this.layoutsContainer.position.set(Scale.X(-49), Scale.Y(1145.5))
		//if (this.playWindow.Height >= 5 && Settings.Screens == 2) this.layoutsContainer.position.set(Scale.X(-49), Scale.Y(66.5))

		//AddScreenShot Layout to message intro and final message container 
		indexpot = null;

		//this.CreateInfoStats(layoutsContainer)
	}

	public override OnResize(): void {
		this.responsiveView?.setAvailableSize(window.innerWidth, window.innerHeight);
		this.responsiveViewStats?.setAvailableSize(window.innerWidth, window.innerHeight);
		this.transitionView?.OnResize();
		//this.awardJPShowPIXIAPP?.ViewPIXIAPP()?.updateTransform();
		this.awardJPShowPIXIAPP?.OnResize();
		this.bonusAwardAnimation?.restart();
		this.ScaleGame();
		this.resizeCallback?.();

	}

	protected override CreateAwarViewPIXIAPP() {
		this.bonusGameAwardViewPIXIAPP = new PIXI.Container();
		this.bonusGameAwardViewPIXIAPP.name = "bonusGameAwardViewPIXIAPP";
		this.bonusGameAwardViewPIXIAPP.alpha = 0;
		//this.bonusGameAwardViewPIXIAPP.position.set(Settings.ScreenWidth,0);
		this.reelsView.addChild(this.bonusGameAwardViewPIXIAPP);


		//create container and spine bonus title 
		let bonusWinAwardTitle = new PIXI.Container();
		bonusWinAwardTitle.name = "bonusWinAwardTitle";
		this.bonusGameAwardViewPIXIAPP.addChild(bonusWinAwardTitle);
		this.spineBonusTitleAward = CreateSpineResources(this.jsonBonusWinTitleSpine);
		//this.spineBonusTitleAward.scale.set(Scale.XY(1));		
		this.spineBonusTitleAward.state.timeScale = 1.5;
		bonusWinAwardTitle.x = Scale.X(78);
		bonusWinAwardTitle.y = Scale.Y(199);
		bonusWinAwardTitle.addChild(this.spineBonusTitleAward);



		//create container and spine bonus title 
		let bonusWinAwardContainer = new PIXI.Container();
		bonusWinAwardContainer.name = "bonusWinAwardContainer";
		this.bonusGameAwardViewPIXIAPP.addChild(bonusWinAwardContainer);
		this.spineWinAward = CreateSpineResources(this.jsonWinAwardBonusSpine);
		this.spineWinAward.state.timeScale = 1.5
		//bonusWinAwardContainer.x = Settings.ScreenWidth / 2;
		bonusWinAwardContainer.y = Settings.ScreenHeight / 2;
		bonusWinAwardContainer.addChild(this.spineWinAward);

		console.log("Spine:", this.spineWinAward);



		//create container 
		let containerValue = new PIXI.Container();
		containerValue.name = "containerValue";
		//containerValue.pivot.set(this.positionSpinnableReelsSpinePivotContainer.width, this.positionSpinnableReelsSpinePivotContainer.height);
		containerValue.scale.set(1, -1);
		containerValue.position.y = (Settings.ScreenHeight * (Settings.Screens - 1)) * -1;


		//add container to spine
		let containerchildrensSpine = this.spineWinAward?.children as PIXI.Container[];
		containerchildrensSpine?.forEach((container) => {
			if (container.name == "containerValue") {
				//create Win Text SRA
				this.containerValueWinAwardText = new PIXI.Text("?", {
					fontFamily: 'NotoSansDisplay-Bold',
					fontSize: 230,
					fontWeight: 'bold',
					fill: ["#F2E416", "#F2BE22", "#C2760E", "#F2BE22", "#F2E416"], // gradient
					stroke: 'black',
					strokeThickness: 10,
					//wordWrap: true,			
					lineJoin: 'round',
					//textBaseline : "middle",			
				});
				this.containerValueWinAwardText.scale.set(1, -1);
				this.containerValueWinAwardText.anchor.set(0.5, 0.5);
				container.addChild(this.containerValueWinAwardText)
			}
		});

		containerchildrensSpine = null;


		//create Win Text SRA
		let containerValueWinAward = new PIXI.Text("?", {
			fontFamily: 'NotoSansDisplay-Bold',
			fontSize: Scale.fh(120),
			fontWeight: 'bold',
			fill: ["#F2E416", "#F2BE22", "#C2760E", "#F2BE22", "#F2E416"], // gradient
			stroke: 'black',
			strokeThickness: Scale.fh(10),
			//wordWrap: true,			
			lineJoin: 'round',
			//textBaseline : "middle",			
		});
		containerValueWinAward.anchor.set(0.5, 0.5);
		containerValue.addChild(containerValueWinAward)
	}

	protected override async OnCometEnd(): Promise<void> {

		const Awards = this.scatterPositions[this.currentScatterCometIndex];
		const awardOption = Awards?.AwardOptionPosition.AwardOption;

		console.log(`OnCometEnd index ${this.currentScatterCometIndex}/${this.scatterPositions.length}`, Awards);
		//let JPAward = this.simpleEndSpinAction.find(b=>b.Phase == "End").WinSinceBonusStart.SequentialProgressiveNonProgressiveWins;
		//let awardJPOption = Awards.AwardOptionPosition.AwardOption;

		this.spineBonusTitleAward?.state?.setAnimation(0, "anim", false);
		this.spineWinAward?.state?.setAnimation(0, "anim", false);
		// start showtime for cash or jackpot
		if (awardOption.AwardType == AwardType.BetMultiplier ||
			awardOption.AwardType == AwardType.Credit
		) {
			this.SendWinInfo(Awards.Value.InCents, null);
			//this.timeoutNextCommetCash.Start();
			this.isShowed = true;
			this.NextComet();

		}
		else if (awardOption.AwardType == AwardType.Jackpot) {

			const jackpotAwardOption: JackpotAwardOption = awardOption as JackpotAwardOption;

			if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStepShared)
				if (this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row < this.spinnableReels2.GetWindowSymbolSize().Height / 2 && Settings.Enable2plus1 == true && Settings.Screens == 3 ||
					this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row < this.spinnableReels2.GetWindowSymbolSize().Height / 2 && Settings.Screens == 2) this.bonusGameAwardViewPIXIAPP.visible = false;

			this.SendWinInfo(Awards.Value.InCents, jackpotAwardOption.JackpotLevel);
			//this.audio.Play(this.resid.ScopedResourceName("clasploop"));

			let jackpotShowDuration = 0;
			if (this.jackpotSharedShow != null) {
				jackpotShowDuration = this.jackpotSharedShow?.GetDuration(jackpotAwardOption.JackpotLevel)
			}
			else {
				jackpotShowDuration = JackpotShowtimeDuration[jackpotAwardOption.JackpotLevel];
			}

			assertNotLess(5000, jackpotShowDuration, "jackpotShowtimeDuration should have some minimum duration");

			await this.StartShowWin(jackpotAwardOption.JackpotLevel, 2000, Awards.Value);

			// if (Awards.AwardOptionPosition.AwardOption.AwardName == JackpotLevel.Jp4) {
			// 	// eslint-disable-next-line @typescript-eslint/no-floating-promises
			// 	void service.api.jpShowStart({
			// 		jackpotName: jackpotAwardOption.JackpotLevel,
			// 		duration: 55000,
			// 		win: Awards.Value.InCents,
			// 	});
			// }

			this.isShowed = false;

			setTimeout(() => {
				this.StopFontain(Awards.AwardOptionPosition.AwardOption.AwardName as JackpotLevel);

				if (this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row < this.spinnableReels2.GetWindowSymbolSize().Height / 2 && Settings.Enable2plus1 == true && Settings.Screens == 3 ||
					this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row < this.spinnableReels2.GetWindowSymbolSize().Height / 2 && Settings.Screens == 2) {
					this.bonusGameAwardViewPIXIAPP.visible = true;
				}


				if (this.jackpotSharedHit != null) {
					this.jackpotSharedShow?.ShowShared(this.jackpotSharedHit);
					setTimeout(() => {
						this.jackpotSharedHit = null;
						this.NextComet();
					}, this.jackpotSharedShow?.GetDuration(this.jackpotSharedHit.JackpotLevel) + 500)
				}
				else {
					this.NextComet()
				}
			}, 2000)
		}
	}

	protected override InternalNextComet() {
		//this.isShowed = true;
		this.currentScatterCometIndex++;
		if (this.currentScatterCometIndex >= this.scatterPositions.length) {
			// Log.Debug(this.logGroup, "Comets complete");			
			this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(this.startAction.WinSinceGameStart.TotalWin.InCents), service.moneyFormatter.FormatCurrency(this.startAction.WinSinceGameStart.TotalWin.InCents))
			this.timeoutFinalMessageState.Start();
		}
		else {
			if (SpinAndHoldState.CometCollect == this.stateMachine.State()) {
				this.isShowed = false;
				if ((this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row >= this.spinnableReels2.GetWindowSymbolSize().Height / 2) && this.isMovedWincontainer == true) {
					//this.animBottomToTopWinContainer.restart();
					let yPosition = this.isDouble ? 0 : (- (COMET_PATH.height / 2) * 0.9);
					// if (Settings.Enable2plus1 == true) yPosition = Scale.Y(1085);
					this.bonusAwardAnimation = gsap.to(this.bonusGameAwardViewPIXIAPP
						, {
							duration: 1,
							y: yPosition,
						});

					//its moved need turn of flag for dont move all time
					this.isMovedWincontainer = false;
					//add some delay for wait move container and later show comet anim
					this.timeoutCometShowtime.Start();
					//setTimeout(() => { this.CometShowtime(this.scatterPositions[this.currentScatterCometIndex]); }, 1000)
				} else {
					//jumps to cometshowTime dosent need add delay here
					this.CometShowtime(this.scatterPositions[this.currentScatterCometIndex]);
				}
			}
		}
	}

	protected override CreateSpinsRemaining() {
		//if (this.playWindow.Height >= 5) return
		//create container and spine Spins Remaining
		this.spinsRemainingContainer = new Container();
		this.spinsRemainingContainer.name = "spinsRemainingContainer";

		this.spineSpinsRemaining = CreateSpineResources(this.jsonSpinsRemainingSpine);
		this.spinsRemainingContainer.addChild(this.spineSpinsRemaining);


		//this.spineSpinsRemaining.scale.set(Scale.XY(1.5));
		//this.spineSpinsRemaining.state.apply(this.spineSpinsRemaining.skeleton);
		//this.spineSpinsRemaining.state.update(0);
		this.spinsRemainingContainer.pivot.set(this.spineSpinsRemaining.width / 2, this.spineSpinsRemaining.height / 2);

		// if (this.playWindow.Height < 4) {
		this.bonusGameInfoStats.addChild(this.spinsRemainingContainer)
		// 	this.spinsRemainingContainer.y = (Settings.ScreenHeight - this.spineSpinsRemaining.height / 2) - Scale.XY(200)
		// }
		// else {
		// 	this.layoutsContainer.addChild(this.spinsRemainingContainer);
		// 	this.spineSpinsRemaining.scale.set(Scale.XY(0.9));
		// 	this.spinsRemainingContainer.x = Scale.X(1732.83);
		// 	this.spinsRemainingContainer.y = Scale.Y(2.5);
		// }
		this.spineSpinsRemaining?.state?.setAnimation(0, "anim", true);
		//spinsRemainingContainer.scale.set(Scale.XY(0.7));

		//create text spins remaning info
		let spinRemainingTextInfoPIXIAPP = new Text(this.translator.t.totalleftHoldAndSpin, {
			fontFamily: 'NotoSansDisplay-Bold',
			fontSize: 35,
			fontWeight: 'bold',
			fill: ["#F20505", "#F20505", "#F20505", "#F20505", "#F20505"], // gradient
			stroke: 'white',
			strokeThickness: 10,
			wordWrap: true,
			lineJoin: 'round',
			align: "center",
			dropShadow: true,
			dropShadowColor: "#000000",
			dropShadowDistance: 5,
			dropShadowAngle: 0.52,
			dropShadowAlpha: 1,
			//textBaseline : "middle",			
		});
		spinRemainingTextInfoPIXIAPP.anchor.set(0.5, 0.5);
		spinRemainingTextInfoPIXIAPP.scale.set(1, -1);
		spinRemainingTextInfoPIXIAPP.position.set(-50, 0);


		//create spins remaning 
		let spinRemainingTextPIXIAPP = new Text(this.session.RunsRemaining, {
			fontFamily: 'NotoSansDisplay-Bold',
			fontSize: 100,
			fontWeight: 'bold',
			fill: ["#F20505", "#F20505", "#F20505", "#F20505", "#F20505"], // gradient
			stroke: 'white',
			strokeThickness: 10,
			//wordWrap: true,			
			lineJoin: 'round',
			dropShadow: true,
			dropShadowColor: "#000000",
			dropShadowDistance: 5,
			dropShadowAngle: 0.52,
			dropShadowAlpha: 1,
			//textBaseline : "middle",			
		});
		spinRemainingTextPIXIAPP.anchor.set(0.5, 0.5);
		spinRemainingTextPIXIAPP.scale.set(1, -1);
		spinRemainingTextPIXIAPP.position.set(100, 0);
		this.spinRemainingTextPIXIAPP = spinRemainingTextPIXIAPP;

		//add container to spine
		let containerchildrensSpine = this.spineSpinsRemaining?.children as Container[];
		containerchildrensSpine?.forEach((container) => {
			if (container.name == "containerValue") {
				container.addChild(spinRemainingTextInfoPIXIAPP);
				container.addChild(spinRemainingTextPIXIAPP);
			}
		});

		this.translator.SetOnLanguageChangedCallback(() => {

			//winTextPIXIAPP.text = this.translator.t.totalwinHoldAndSpin;
			spinRemainingTextInfoPIXIAPP.text = this.translator.t.totalleftHoldAndSpin;
		});
	}

	protected override WinCountShow() {
		// super.WinCountShow();
		this.bonusMultiplier?.Hide()
		//change position for winContainer 
		if (this.bonusGameAwardViewPIXIAPP != null) {
			// let xPosition = 0;
			gsap.to(this.bonusGameAwardViewPIXIAPP, { alpha: 1, duration: 1 });//(this.bonunsGameAwardViewPIXIAPP, { x: xPosition, duration: 1, ease: Elastic.easeOut.config(0.50, 0.4) });
		}

		this.SetPositionAwardContainer()


		// if (globalThis.jackpotDisplayGlobal != null) {
		// 	TweenLite.to(globalThis.jackpotDisplayGlobal.View(), 0.8, {
		// 		alpha: 0
		// 	});
		// }
	}

	protected override SetPositionAwardContainer() {

		if (this.isDouble) {

			if (this.scatterPositions[0].AwardOptionPosition.Row >= this.spinnableReels2.GetWindowSymbolSize().Height / 2) {
				//top position
				this.bonusGameAwardViewPIXIAPP.position.y = COMET_PATH.height * -1;//Scale.Y(-58);
				// if(Settings.Enable2plus1 == true )this.bonunsGameAwardViewPIXIAPP.position.y = Scale.Y(1085);
				this.isMovedWincontainer = false;
			} else {
				//bottom postion
				this.bonusGameAwardViewPIXIAPP.position.y = COMET_PATH.height;
				// if(Settings.Enable2plus1 == true )this.bonunsGameAwardViewPIXIAPP.position.y = Scale.Y(1988);
				this.isMovedWincontainer = true;
			}
		}
		else {

			if (this.scatterPositions[0].AwardOptionPosition.Row >= this.spinnableReels2.GetWindowSymbolSize().Height / 2) {
				//top position
				this.bonusGameAwardViewPIXIAPP.position.y = (COMET_PATH.height + COMET_PATH.height * -1);//Scale.Y(-58);
				// if(Settings.Enable2plus1 == true )this.bonunsGameAwardViewPIXIAPP.position.y = Scale.Y(1085);
				this.isMovedWincontainer = false;
			} else {
				//bottom postion
				this.bonusGameAwardViewPIXIAPP.position.y = COMET_PATH.height / 4;
				// if(Settings.Enable2plus1 == true )this.bonunsGameAwardViewPIXIAPP.position.y = Scale.Y(1988);
				this.isMovedWincontainer = true;
			}

		}
	}

	protected override DestinationComet(): Point {
		// return super.DestinationComet()
		if (this.isDouble) {
			if (this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row <= this.spinnableReels2.GetWindowSymbolSize().Height / 2 - 1) {
				// where the win is on the bottom
				return TranslateScreen1To1(new Rect(Scale.X(0), Scale.Y(1080), Scale.W(1920), Scale.H(1080))).Center();
			}
			else {
				// where the win is on the top
				return TranslateScreen1To1(new Rect(Scale.X(0), Scale.Y(0), Scale.W(1920), Scale.H(1080))).Center();
			}
		}
		else {
			if (this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row <= this.spinnableReels2.GetWindowSymbolSize().Height / 2 - (this.playWindow.Height / 2 - 1)) {
				// where the win is on the bottom
				return TranslateScreen1To1(new Rect(Scale.X(0), Scale.Y(1080 / 4), Scale.W(1920), Scale.H(1080))).Center();
			}
			else {
				// where the win is on the top
				return TranslateScreen1To1(new Rect(Scale.X(0), Scale.Y(-(1080 / 2)), Scale.W(1920), Scale.H(1080))).Center();
			}
		}
	}


	private ScaleGame() {

		if (!this.created) return;

		this.SetToDefault();

		this.messageContainerPIXIAPP.position.y = this.isDouble 
		? (Scale.H(1080 * 2) + this.messageContainerPIXIAPP.height) / 4
		:Scale.H(1080) / 5
		
		let jackpotPotElementSpine = this.layoutPotsElementsMap.get(MultiBonusType.Jackpot).layoutSpine;
		let multiplierPotElementSpine = this.layoutPotsElementsMap.get(MultiBonusType.Multiplier).layoutSpine;
		let doublePotElementSpine = this.layoutPotsElementsMap.get(MultiBonusType.Double).layoutSpine;

		const labelRect = new Rect(0, 0, 597, 223);
		const statsSize = new Size((435 / 2), (159 / 2));

		this.responsiveStatsContainer.percentX = 0;
		this.responsiveStatsContainer.percentY = 0;
		this.responsiveStatsContainer.percentWidth = 1
		this.responsiveStatsContainer.percentHeight = 0.13;

		this.baseGameContainer.percentX = 0;
		this.baseGameContainer.percentY = 0.13;
		this.baseGameContainer.percentWidth = 1;
		this.baseGameContainer.percentHeight = 0.72;

		this.containerBonusViewApp.fixedHeight = Scale.H(1080);
		this.statsContainer.fixedHeight = Scale.H(200);


		// this.messageContainerPIXIAPP.position.set(0,0);


		// let baseSize = new Size(Scale.W(1920), Scale.H(1080));
		// let calculatedPosition: number = 0;

		if (GetOrientation() == Orientation.Landscape) {

			this.containerBonusViewApp.fixedHeight = Scale.H(1080 * 2);
			this.statsContainer.fixedHeight = Scale.H(1080 * 2);

			if (this.isDouble) {

				this.responsiveStatsContainer.percentWidth = 0.33 * 0.9;
				this.responsiveStatsContainer.percentHeight = 0.85;
				this.responsiveStatsContainer.percentX = 0;
				this.responsiveStatsContainer.percentY = 0;

				this.baseGameContainer.percentWidth = 0.33;
				this.baseGameContainer.percentHeight = 0.85;
				this.baseGameContainer.percentX = 0.33;
				this.baseGameContainer.percentY = 0;

				// column 1
				{
					const elemHeight = this.statsContainer.fixedHeight / 5; //this.layoutsContainer.children.length;
					const elemWidth = this.statsContainer.fixedWidth; //this.layoutsContainer.children.length;

					const scalex = labelRect.width / elemWidth
					const scaley = labelRect.height / elemHeight;
					const scale = Math.min(scalex, scaley) * 3;
					this.spinsRemainingContainer.scale.set(scale);
					this.spinsRemainingContainer.x = (labelRect.width);
					this.spinsRemainingContainer.y = elemHeight;//labelRect.height / 2 + elemHeight / 2;

					this.scatterWinCountContainer.scale.set(scale);
					this.scatterWinCountContainer.x = (labelRect.width);
					this.scatterWinCountContainer.y = elemHeight * 2;//elemHeight / 2 + (labelRect.height);//labelRect.height / 2 + elemHeight / 2;/

					const scaleXlabel = labelRect.width / elemWidth;
					const scaleYlabel = labelRect.height / this.statsContainer.fixedHeight;
					const scaleLabel = Math.min(scaleXlabel, scaleYlabel) * 5;
					const labelPostionX = labelRect.width;



					if (jackpotPotElementSpine) {

						jackpotPotElementSpine.scale.set(scaleLabel);
						jackpotPotElementSpine.position.x = labelPostionX
						jackpotPotElementSpine.position.y = elemHeight * 3//((elemHeight / 6) * 2 + (labelRect.height * scale)) * 2;
					}
					if (doublePotElementSpine) {

						doublePotElementSpine.scale.set(scaleLabel);
						doublePotElementSpine.position.x = labelPostionX
						doublePotElementSpine.position.y = elemHeight * 4//((elemHeight / 6) * 2+ (labelRect.height * scale)) * 3;
					}
					if (multiplierPotElementSpine) {

						multiplierPotElementSpine.scale.set(scaleLabel);
						multiplierPotElementSpine.position.x = labelPostionX
						multiplierPotElementSpine.position.y = elemHeight * 5//((elemHeight / 6) * 2 + (labelRect.height * scale)) * 4;
					}

					this.layoutsContainer.position.y = (this.containerBonusViewApp.fixedHeight - this.layoutsContainer.height) / 2;
				}

				//column 2
				{

					this.reelsView.position.x = (this.containerBonusViewApp.fixedWidth) / 2;
					this.reelsView.position.y = (this.containerBonusViewApp.fixedHeight) / 2;



				}

				//column 3
				//spin panel ... 


				return;
			}

			//row 1 spinsremaining & wincount
			{
				const elemWidth = this.statsContainer.fixedWidth / 2;

				const scaleX = labelRect.width / (this.statsContainer.fixedWidth / 2);
				const scaleY = labelRect.height / this.statsContainer.fixedHeight;
				const scale = (scaleX + scaleY) / 2;

				const scaleXlabel = elemWidth / labelRect.width;
				const scaleYlabel = (this.statsContainer.fixedHeight / 2) / labelRect.height;
				const scaleLabel = Math.min(scaleXlabel, scaleYlabel);

				const gap = (this.statsContainer.fixedWidth - (labelRect.width * scaleLabel * 2)) / 3

				this.spinsRemainingContainer.scale.set(scale);
				this.spinsRemainingContainer.x = this.statsContainer.fixedWidth / 4;
				this.spinsRemainingContainer.y = labelRect.height / 2;

				this.scatterWinCountContainer.scale.set(scale);
				this.scatterWinCountContainer.x = (this.statsContainer.fixedWidth / 4) * 3;
				this.scatterWinCountContainer.y = labelRect.height / 2;

				//jackpot
				if (jackpotPotElementSpine) {

					jackpotPotElementSpine.scale.set(scaleLabel * 0.9);
					jackpotPotElementSpine.position.x = gap + (elemWidth / 2);//labelRect.width / 6;
					jackpotPotElementSpine.position.y = labelRect.height;//elemHeight + (labelRect.height * scale);
				}
				//multiplier
				if (multiplierPotElementSpine) {

					multiplierPotElementSpine.scale.set(scaleLabel * 0.9);
					multiplierPotElementSpine.position.x = (gap * 2) + elemWidth * 1.5//gap + ((labelRect.width / 2 + this.statsContainer.fixedWidth) / 4)  * 3//(labelRect.width - labelRect.width / 6);
					multiplierPotElementSpine.position.y = labelRect.height;//(elemHeight + (labelRect.height * scale)) * 3;
				}
			}

			this.containerBonusViewApp.fixedHeight = Scale.H(1080);
			this.statsContainer.fixedHeight = Scale.H(200);

			const elemWidth = this.statsContainer.fixedWidth / 4;
			const elemHeight = this.statsContainer.fixedHeight;

			const scaleX = elemWidth / labelRect.width;
			const scaleY = this.statsContainer.fixedHeight / labelRect.height;
			const scale = Math.min(scaleX, scaleY);

			const gap = (this.statsContainer.fixedWidth - (labelRect.width * scale * 4)) / 5


			if (jackpotPotElementSpine) {
				jackpotPotElementSpine.scale.set(scale * 0.9);
				jackpotPotElementSpine.position.x = gap + (elemWidth / 2);
				jackpotPotElementSpine.position.y = this.statsContainer.fixedHeight / 2;//elemHeight + (labelRect.height * scale) * 2;

			}

			if (multiplierPotElementSpine) {
				multiplierPotElementSpine.scale.set(scale * 0.9);
				multiplierPotElementSpine.position.x = 2 * gap + (elemWidth * 1.5)//(gap + elemWidth) * 2// labelRect.width / 2;
				multiplierPotElementSpine.position.y = this.statsContainer.fixedHeight / 2;//elemHeight + (labelRect.height * scale) * 4;
			}

			const scaleStatsX = statsSize.Width / elemWidth;
			const scaleStatsY = statsSize.Height / elemHeight;
			// const scaleStatsX = this.statsContainer.fixedWidth / statsSize.Width;
			// const scaleStatsY = this.statsContainer.fixedHeight / statsSize.Height;
			const scaleStats = Math.min(scaleStatsX, scaleStatsY);

			this.spinsRemainingContainer.scale.set(scaleStats);
			this.spinsRemainingContainer.x = 3 * gap + (elemWidth * 2.5)///labelRect.width / 2;
			this.spinsRemainingContainer.y = this.statsContainer.fixedHeight / 2;

			this.scatterWinCountContainer.scale.set(scaleStats);
			this.scatterWinCountContainer.x = 4 * gap + (elemWidth * 3.5)///labelRect.width / 2;
			this.scatterWinCountContainer.y = this.statsContainer.fixedHeight / 2;

			

		}
		else if (GetOrientation() == Orientation.Portrait) {

			if (this.isDouble) {

				this.containerBonusViewApp.fixedHeight = Scale.H(1080);
				this.statsContainer.fixedHeight = Scale.H(1080);

				this.responsiveStatsContainer.percentX = 0;
				this.responsiveStatsContainer.percentY = 0;
				this.responsiveStatsContainer.percentWidth = 1
				this.responsiveStatsContainer.percentHeight = 0.25;

				this.baseGameContainer.percentX = 0;
				this.baseGameContainer.percentY = 0.25;
				this.baseGameContainer.percentWidth = 1;
				this.baseGameContainer.percentHeight = 0.25;



				//row1
				{
					//spins remaining

					// const scaleX = availableWidth / labelRect.width
					// const scaleY = elemHeight / labelRect.height;
					const elemWidth = this.statsContainer.fixedWidth / 3;

					const scaleX = labelRect.width / (this.statsContainer.fixedWidth / 2);
					const scaleY = labelRect.height / this.statsContainer.fixedHeight;
					const scale = (scaleX + scaleY) / 2;

					const scaleXlabel = elemWidth / labelRect.width;
					const scaleYlabel = this.statsContainer.fixedHeight / labelRect.height;
					const scaleLabel = Math.min(scaleXlabel, scaleYlabel);


					const gap = (this.statsContainer.fixedWidth - (labelRect.width * scaleLabel * 3)) / 4

					this.spinsRemainingContainer.scale.set(scale * 2);
					this.spinsRemainingContainer.x = this.statsContainer.fixedWidth / 4;
					this.spinsRemainingContainer.y = labelRect.height / 2;

					this.scatterWinCountContainer.scale.set(scale * 2);
					this.scatterWinCountContainer.x = (this.statsContainer.fixedWidth / 4) * 3;
					this.scatterWinCountContainer.y = labelRect.height / 2;

					//jackpot
					if (jackpotPotElementSpine) {

						jackpotPotElementSpine.scale.set(scaleLabel * 0.9);
						jackpotPotElementSpine.position.x = gap + (elemWidth / 2);//labelRect.width / 6;
						jackpotPotElementSpine.position.y = labelRect.height * 1.5;//elemHeight + (labelRect.height * scale);
					}
					//double
					if (doublePotElementSpine) {

						doublePotElementSpine.scale.set(scaleLabel * 0.9);
						doublePotElementSpine.position.x = (gap * 2) + elemWidth * 1.5;
						doublePotElementSpine.position.y = labelRect.height * 1.5;//(elemHeight + (labelRect.height * scale)) * 2;
					}
					//multiplier
					if (multiplierPotElementSpine) {

						multiplierPotElementSpine.scale.set(scaleLabel * 0.9);
						multiplierPotElementSpine.position.x = (gap * 3) + elemWidth * 2.5//gap + ((labelRect.width / 2 + this.statsContainer.fixedWidth) / 4)  * 3//(labelRect.width - labelRect.width / 6);
						multiplierPotElementSpine.position.y = labelRect.height * 1.5;//(elemHeight + (labelRect.height * scale)) * 3;
					}

				}
				//row2
				{
					this.reelsView.position.x = (this.containerBonusViewApp.fixedWidth) / 2;
					this.reelsView.position.y = (this.containerBonusViewApp.fixedHeight) / 4 * 3;


				}
				//const labelRect = new Rect(0, 0, Scale.W(1920), Scale.H(275));

				//this.reelsView.position.x = (availableWidth - this.containerBonusViewApp.width / 4)//this.containerBonusViewApp.fixedWidth / 2 - (this.reelsView.width / 4);
				//this.reelsView.position.y = 0;//(availableHeight - this.containerBonusViewApp.height) / 4//this.containerBonusViewApp.fixedHeight / 2 - (this.reelsView.height / 4);



				return;
			}

			// this.responsiveStatsContainer.percentX = 0;
			// this.responsiveStatsContainer.percentY = 0;
			// this.responsiveStatsContainer.percentWidth = 1
			// this.responsiveStatsContainer.percentHeight = 0.13;

			// this.baseGameContainer.percentX = 0;
			// this.baseGameContainer.percentY = 0.13;
			// this.baseGameContainer.percentWidth = 1;
			// this.baseGameContainer.percentHeight = 0.72;


			//row 1 spinsremaining & wincount
			{

				const elemHeight = this.statsContainer.fixedHeight / 2;


				//stats
				{
					const elemWidthStats = this.statsContainer.fixedWidth / 2;

					const scaleXStats = elemWidthStats / statsSize.Width;
					const scaleYStats = elemHeight / statsSize.Height;

					const scaleStats = Math.min(scaleXStats, scaleYStats);

					const gapStats = (this.statsContainer.fixedWidth - (statsSize.Width * scaleStats * 2)) / 3

					this.spinsRemainingContainer.scale.set(scaleStats * 2);
					this.spinsRemainingContainer.x = gapStats / 2 + elemWidthStats / 4;
					this.spinsRemainingContainer.y = elemHeight / 4;

					this.scatterWinCountContainer.scale.set(scaleStats * 2);
					this.scatterWinCountContainer.x = gapStats * 2.5 + (elemWidthStats / 4);
					this.scatterWinCountContainer.y = elemHeight / 4;
				}
				//labels
				{
					const elemWidth = this.statsContainer.fixedWidth / 3;

					const scaleXlabel = elemWidth / labelRect.width;
					const scaleYlabel = this.containerBonusViewApp.fixedHeight / labelRect.height;
					const scaleLabel = Math.min(scaleXlabel, scaleYlabel);

					const gap = (this.statsContainer.fixedWidth - (labelRect.width * scaleLabel * 3)) / 4

					if (jackpotPotElementSpine) {

						jackpotPotElementSpine.scale.set(scaleLabel);
						jackpotPotElementSpine.position.x = this.statsContainer.fixedWidth / 4 ///gap / 2 + (elemWidth / 2);//labelRect.width / 6;
						jackpotPotElementSpine.position.y = elemHeight * 3;//elemHeight + (labelRect.height * scale);
					}

					//multiplier
					if (multiplierPotElementSpine) {

						multiplierPotElementSpine.scale.set(scaleLabel);
						multiplierPotElementSpine.position.x = this.statsContainer.fixedWidth / 4 * 3//gap + ((labelRect.width / 2 + this.statsContainer.fixedWidth) / 4)  * 3//(labelRect.width - labelRect.width / 6);
						multiplierPotElementSpine.position.y = elemHeight * 3;//(elemHeight + (labelRect.height * scale)) * 3;
					}


				}

				// //jackpot
				// if (jackpotPotElementSpine) {

				// 	jackpotPotElementSpine.scale.set(scaleLabel * 0.9);
				// 	jackpotPotElementSpine.position.x = gap + (elemWidth / 2);//labelRect.width / 6;
				// 	jackpotPotElementSpine.position.y = labelRect.height;//elemHeight + (labelRect.height * scale);
				// }
				// //multiplier
				// if (multiplierPotElementSpine) {

				// 	multiplierPotElementSpine.scale.set(scaleLabel * 0.9);
				// 	multiplierPotElementSpine.position.x = (gap * 2) + elemWidth * 1.5//gap + ((labelRect.width / 2 + this.statsContainer.fixedWidth) / 4)  * 3//(labelRect.width - labelRect.width / 6);
				// 	multiplierPotElementSpine.position.y = labelRect.height;//(elemHeight + (labelRect.height * scale)) * 3;
				// }
			}


		}



		this.reelsView.position.x = (this.containerBonusViewApp.fixedWidth) / 2;
		this.reelsView.position.y = (this.containerBonusViewApp.fixedHeight) / 2

	}

	private SetToDefault() {

		this.bonusGameAwardViewPIXIAPP.position.x = 0;
		this.bonusGameAwardViewPIXIAPP.position.y = 0;

		this.messageContainerPIXIAPP.position.set(0,0)

		this.layoutsContainer.position.x = 0;
		this.layoutsContainer.position.y = 0;

		this.layoutsContainer.children.forEach(ele => {
			ele.scale.set(1);
			ele.x = 0;
			ele.y = 0;
		});
		this.reelsView.position.x = 0;
		this.reelsView.position.y = 0;
		// this.reelsView.scale.set(1);

		this.responsiveStatsContainer.percentWidth = 1;
		this.responsiveStatsContainer.percentHeight = 1;
		this.responsiveStatsContainer.percentX = 0;
		this.responsiveStatsContainer.percentY = 0;

		this.baseGameContainer.percentWidth = 1;
		this.baseGameContainer.percentHeight = 1;
		this.baseGameContainer.percentX = 0;
		this.baseGameContainer.percentY = 0;


	}

	public override GameExit(): void {
		super.GameExit();
		this.bonusAwardAnimation?.kill();
		this.bonusAwardAnimation = null;
		Safe(() => {
			this.responsiveView.destroy({ children: true });
			this.responsiveViewStats.destroy({ children: true });
			this.awardJPShowPIXIAPP.Destroy();
		})
	}

}
